import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getError } from '@/component/project/handler/SettingChatbotHandler.js';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { I18n, Storage } from 'aws-amplify';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './RichTextUI.css';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';

function myBlockRenderer(contentBlock) {
    const type = contentBlock.getType();
    // Convert image type to mediaComponent
    if (type === 'atomic') {
        return {
            component: MediaComponent,
            editable: false,
            props: {
                foo: 'bar',
            },
        };
    }
}
class MediaComponent extends React.Component {
    render() {
      const { block, contentState } = this.props;
      const { foo } = this.props.blockProps;
      const data = contentState.getEntity(block.getEntityAt(0)).getData();
      

      const emptyHtml = ' ';
      return (
        <div>
          {emptyHtml}
          <img
            src={data.src}
            alt={data.alt || ''}
            style={{height: data.height || 'auto', width: data.width || 'auto'}}
          />
        </div>
      );
    }
}

export default function RichTextEditorForSettingChatbot(props) {
    const defaultValue = props?.defaultValue ? getRichTextFieldContent(props?.defaultValue) : '';
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const timeStampDefault = new Date().getTime();

    useEffect(() => {
        props.setValue(JSON.stringify(draftToHtml(convertToRaw(editorState.getCurrentContent()))));
    }, [editorState]);

    useEffect(() => {
        props?.defaultValue ?   
            setEditorState(EditorState.createWithContent(
                ContentState.createFromBlockArray(htmlToDraft(JSON.parse(props.defaultValue)))
            ))
    : setEditorState(EditorState.createEmpty())
    }, [props?.isUpdateData])

    useEffect(() => {
        const elem = document.querySelector(`.custom-class${timeStampDefault}`);
        if (elem) {
            let visible = window?.getComputedStyle(elem)?.getPropertyValue('visibility');
            let elemUploadFile = elem.querySelector('.rdw-image-modal-upload-option');
            if(elemUploadFile) {
                elemUploadFile.addEventListener('click', () =>{
                    elem.style.display = 'flex';
                })
            }
            if (visible === 'visible') {
                elem.style.display = 'flex';
            } else {
                elem.style.display = 'none';
            }
        }
    });

    const uploadImageCallBack = async (file) => {
        let result = await Storage.put(`corp/image/${encodeURIComponent(file.name)}`, file, {
            contentType: file.type,
            level: 'public',
            contentDisposition: `inline; filename=${encodeURIComponent(file.name)}`,
            acl: "public-read",
        });

        let fileUpload = {
            fileUrl: result.key,
            type: Constant.S3_FILE_TYPE.TICKET_FILE
        }

        // let link = await Storage.get(result.key, { level: 'public' })
        let link = getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
        return { data: { link: `${link}` } };
    };

    const onEditorStateChange = (currentEditorState) => {
        let htmlContent = draftToHtml(convertToRaw(currentEditorState.getCurrentContent()));
        let contentText = getRichTextFieldContent(htmlContent);

        if (props?.setIsEdited) {
            if (defaultValue !== contentText) {
                props?.setIsEdited(true);
            }
        }
        setEditorState(currentEditorState);
        validateField(currentEditorState);
    };
    
    const validateField = (newEditorState) => {
        let newErrMsg = '';
        let htmlContent = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
        let contentText = getRichTextFieldContent(htmlContent);
        let maxLength = Constant.SETTING_CHAT_BOT.MAX_LENGTH;
        if (contentText.length > parseInt(maxLength)) {
            newErrMsg = `最大文字数制限（${maxLength}文字）を超えています。`;
        }
        if (!contentText) {
            newErrMsg = I18n.get('COMMSG014');
        }

        if(Utils.isEmptyString(newErrMsg)) {
            props.setErrors(prev => {
                delete prev?.freeMsg;
                return prev;
            })
        }
        else {
            props.setErrors(prev => ({
                ...prev,
                'freeMsg': newErrMsg 
            })); 
        }
        const hasValidateErrors = Utils.isEmptyString(contentText) || !Utils.isEmptyObject(props?.errorlist);
        props?.setIsDisableBtnSubmit(hasValidateErrors);
    }

    return (
        <div className="field-richtext">
            <label className="form-addTicket-label">
            {I18n.get('PLKNOWLB017')}
                <span className="required">*</span>
            </label>
            <div className="form-addTicket-input">
                <div
                    className={`${
                        getError(props?.errorlist, props?.name) ? 'editor editor-err' : 'editor'
                    }`}
                    data-cy="richtext-editor"
                >
                    <Editor
                        blockRendererFn={myBlockRenderer}
                        placeholder={I18n.get('PLKNOWP001')}
                        toolbarOnFocus={true}
                        toolbarClassName={`rich-text__toolbar custom-class${timeStampDefault}`}
                        editorState={editorState}
                        onEditorStateChange={onEditorStateChange}
                        toolbar={{
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: { inDropdown: true },
                            history: { inDropdown: true },
                            image: {
                                uploadCallback: uploadImageCallBack,
                                alt: { present: true, mandatory: true },
                                previewImage: true
                            }
                        }}
                        onBlur={e => {
                            props.onChangePreviewSetting('freeMsg');
                        }}
                        handlePastedText={() => false}
                    />
                </div>
                {getError(props?.errorlist, props?.name) && (
                    <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
                        {I18n.get(getError(props?.errorlist, props?.name))}
                    </p>
                )}
            </div>
        </div>
    );
}
